import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DxAutocompleteModule,
  DxButtonModule,
  DxCheckBoxModule,
  DxDataGridComponent,
  DxDataGridModule,
  DxDropDownBoxModule,
  DxFormModule,
  DxPopoverModule,
  DxSelectBoxModule,
  DxSortableModule,
  DxTagBoxModule,
  DxTextBoxModule,
  DxToolbarModule,
  DxTreeViewModule,
  DxValidationGroupModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { ClickEvent } from 'devextreme/ui/button';
import { ValueChangedEvent as ValueChangedEventCB } from 'devextreme/ui/check_box';
import { ValueChangedEvent as ValueChangedEventSB } from 'devextreme/ui/select_box';

import { EditorPreparingEvent } from 'devextreme/ui/data_grid';
import { AddEvent, DragChangeEvent, ReorderEvent } from 'devextreme/ui/sortable';
import dxTreeView from 'devextreme/ui/tree_view';
import { AppGlobals } from 'src/app/app.globals';
import { ContactsDropdownBoxComponent } from 'src/app/components/contacts-dropdown-box/contacts-dropdown-box.component';
import { DeletePopupComponent } from 'src/app/components/delete-popup/delete-popup.component';
import {
  EditTable,
  EditTableField,
  fields,
  FieldTypeConfig,
  GroupedStructure,
  Table,
  TableField,
} from 'src/app/interfaces/entities/dynamic-table';
import { ConfigService } from 'src/app/services/config.service';
import { ContactService } from 'src/app/services/contact.service';
import { DataAccessService } from 'src/app/services/data-access.service';
import { DynamicTableService } from 'src/app/services/dynamic-tables.service';
import { GridConnectionService } from 'src/app/services/grid-connection.service';
import { PhasesService } from 'src/app/services/phases.service';
import { TemplatesService } from 'src/app/services/templates.service';
import { ScrollableService } from 'src/app/services/misc/scrollable.service';
import { ValidationResult } from 'devextreme/ui/validation_group';
import { SvgIconComponent } from 'src/app/components/svg-icon/svg-icon.component';
import { Phase } from 'src/app/interfaces/entities/project-configuration';
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
import { FormFooterComponent } from "src/app/components/form-footer/form-footer.component";
import { mapConfigurationTree } from 'src/app/helpers/configuration-tree-mapper';

import { SearchableDropdownDirective } from '../../../directives/searchable-dropdown.directive';
@Component({
    selector: 'app-dt-edit',
    imports: [
        CommonModule,
        DxSortableModule,
        DxTextBoxModule,
        DxDataGridModule,
        DxButtonModule,
        DxFormModule,
        DxAutocompleteModule,
        DxSelectBoxModule,
        DxToolbarModule,
        DxValidatorModule,
        DxFormModule,
        FormsModule,
        DxValidationGroupModule,
        DxTagBoxModule,
        DxTreeViewModule,
        ContactsDropdownBoxComponent,
        DxValidatorModule,
        DxCheckBoxModule,
        DeletePopupComponent,
        DxDropDownBoxModule,
        SvgIconComponent,
        GpdButtonComponent,
        DxPopoverModule,
        FormFooterComponent,
        SearchableDropdownDirective,
    ],
    providers: [],
    templateUrl: './dt-edit.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./dt-edit.component.css']
})
export class DynamicTableEditPage implements OnInit {
  hasEditPermission: boolean = false;
  isOwner: boolean = false;
  //Table
  tableId = -1;
  table: Table = {
    id: 0,
    title: '',
    isDefault: false,
    owner: '',
    isDeleted: false,
    structure: [],
    users: [],
    filters: [],
  };

  editTable: EditTable = null;
  data: GroupedStructure[] = [];

  //Lookups
  fieldLookup: any[] = [];
  users: any;
  lookUps: { [key: string]: any[] } = {};
  // filters= ["phase", "milestone", "areaType", "city", "country", "state", "partner", "epc", "remuneration"]
  filters = [
    // {
    //   display: $localize`:@@phase:Phase`,
    //   value: 'phase',
    //   disabled: false,
    // },
    // {
    //   display: $localize`:@@milestone:Milestone`,
    //   value: 'milestone',
    //   disabled: false,
    // },
    {
      display: $localize`:@@state:State`,
      value: 'state',
      disabled: false,
    },
    {
      display: $localize`:@@epc:EPC`,
      value: 'epc',
      disabled: false,
    },
    {
      display: $localize`:@@areaType:Area Type`,
      value: 'areaType',
      disabled: false,
    },
    {
      display: $localize`:@@country:Country`,
      value: 'country',
      disabled: false,
    },
    {
      display: $localize`:@@partner:Partner`,
      value: 'partner',
      disabled: false,
    },
    {
      display: $localize`:@@projectStatus:Project Status`,
      value: 'projectStatus',
      disabled: false,
    },
    {
      display: $localize`:@@remunerationType:Remuneration Type`,
      value: 'remuneration',
      disabled: false,
    },
  ];

  //Table Settings
  emailValue = '';
  filterValue = '';

  //Other
  runningIndex = 0;
  previewVisible: boolean = false;

  backtoTopVisible: boolean = false;

  popupVisible: boolean = false;
  popupContent: {
    text: string;
    confirmFunction: Function;
    cancelFunction: Function;
  } | null = null;

  projectIdFieldId: number | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public appGlobals: AppGlobals,
    private service: DynamicTableService,
    private configService: ConfigService,
    // private phasesService: PhasesService,
    private dataAccessService: DataAccessService,
    private templateService: TemplatesService,
    private gridService: GridConnectionService,
    private contactService: ContactService,
    private scrollableService: ScrollableService
  ) {
    this.updateContextFields = this.updateContextFields.bind(this);
    this.addContextFieldToForm = this.addContextFieldToForm.bind(this);
  }
  async ngOnInit() {
    await Promise.all([this.getLookUps(), this.getUsers()]);
    this.fieldTypeConfigs = fields;

    this.tableId = parseInt(this.route.snapshot.paramMap.get('id'));

    if (this.tableId != 0) {
      await this.getTable();
    } else {
      this.projectIdFieldId = this.fieldLookup.find(x => x.fieldIdentifier == 'projectId')?.fieldId;
      var projectNameFieldId = this.fieldLookup.find(x => x.fieldIdentifier == 'projectName')?.fieldId;
      this.table = {
        id: 0,
        title: $localize`:@@table:Table`,
        isDefault: false,
        owner: AppGlobals.LoggedInUserData.email,
        isDeleted: false,
        users: [
          {
            id: 0,
            email: AppGlobals.LoggedInUserData.email,
            canEdit: true,
          },
        ],
        filters: [],
        structure: [
          {
            id: 0,
            fieldId: this.projectIdFieldId,
            displayName: $localize`:@@general:General`,
            sortingIndex: 0,
            group: true,
            parentId: null,
            value1: null,
            value2: null,
            isDeleted: false,
            fields: [
              {
                id: 0,
                fieldId: projectNameFieldId,
                displayName: $localize`:@@projectName:Project Name`,
                sortingIndex: 1,
                group: false,
                parentId: null,
                value1: null,
                value2: null,
                isDeleted: false,
              },
            ],
          },
        ],
      };
    }
    this.mapData(this.table);
    this.hasEditPermission = this.table.users.find(x => x.email == AppGlobals.LoggedInUserData.email)?.canEdit ?? false;
    this.isOwner = AppGlobals.LoggedInUserData.email == this.table.owner;
    this.scrollableService.scrolled.subscribe(scrollY => {
      this.backtoTopVisible = scrollY > 300;
    });
  }

  @ViewChild('dtEditScrollableDiv', { static: false })
  scrollableDiv: ElementRef;
  hasInitialized = false;
  ngAfterViewChecked(): void {
    if (!this.hasInitialized && this.scrollableDiv) {
      this.scrollableService.setScrollableElement(this.scrollableDiv);
      this.hasInitialized = true;
    }
  }

  scrollToTop() {
    this.scrollableService.scrollTo(0);
  }

  async getTable() {
    this.appGlobals.ShowGlobalLoader();
    try {
      const result = await this.service.getDynamicTable({
        tableId: this.tableId,
      });
      if (result.hasError) {
        AppGlobals.ShowErrorMessage(result.feedback);
      } else {
        this.table = result.table;

        this.table.users.forEach((x, index) => {
          const user = this.lookUps.users.find(y => y.emailAddress == x.email || y.email == this.table.owner);
          if (user != null) {
            user.disabled = true;
          }
        });
        this.table.filters.forEach(x => {
          const filter = this.filters.find(y => y.value == x.type);
          if (filter != null) {
            filter.disabled = true;
          }
        });
      }
    } catch (e) {
      AppGlobals.ShowErrorMessage(e);
    }
    this.appGlobals.HideGlobalLoader();
  }
  async getUsers() {
    try {
      const result = await this.configService.getListOfUsers({});
      if (result.hasError) {
        AppGlobals.ShowErrorMessage(result.feedback);
      } else {
        this.lookUps.users = Array.from(
          result.projectsUsers.map(x => {
            return {
              displayName: x.displayName,
              email: x.emailAddress,
              disabled: false,
            };
          })
        );
        this.users = result.projectsUsers;
      }
    } catch (e) {
      AppGlobals.ShowErrorMessage(e);
    }
  }

  async getLookUps() {
    try {
      const [
        fieldResult,
        departmentResult,
        tasks,
        areaTypes,
        states,
        countries,
        companies,
        persons,
        projectConfiguration,
        remunerationTags,
      ] = await Promise.all([
        this.service.GetFieldLookup({}),
        this.dataAccessService.getDepartments({}),
        this.templateService.getProjectTaskConfigList({}),
        this.templateService.getAreaTypes(),
        this.gridService.getStates({}),
        this.gridService.getCountries({}),
        this.contactService.getCompanies({}),
        this.contactService.getPersons({}),
        this.configService.getProjectConfiguration(),
        this.templateService.getRemunerationTags({}),
      ]);

      if (fieldResult.hasError) {
        AppGlobals.ShowErrorMessage(fieldResult.feedback);
      } else if (departmentResult.hasError) {
        AppGlobals.ShowErrorMessage(departmentResult.feedback);
      } else if (tasks.hasError) {
        AppGlobals.ShowErrorMessage(tasks.feedback);
      } else if (areaTypes.hasError) {
        AppGlobals.ShowErrorMessage(areaTypes.feedback);
      } else if (states.hasError) {
        AppGlobals.ShowErrorMessage(states.feedback);
      } else if (countries.hasError) {
        AppGlobals.ShowErrorMessage(countries.feedback);
      } else if (companies.hasError) {
        AppGlobals.ShowErrorMessage(companies.feedback);
      } else if (persons.hasError) {
        AppGlobals.ShowErrorMessage(persons.feedback);
      } else if (projectConfiguration.hasError) {
        AppGlobals.ShowErrorMessage(projectConfiguration.feedback);
      } else if (remunerationTags.hasError) {
        AppGlobals.ShowErrorMessage(remunerationTags.feedback);
      } else {
        this.fieldLookup = fieldResult.fields;
        this.lookUps.departments = departmentResult.departmentItems.map(x => {
          return {
            id: x.id,
            title: x.name,
          };
        });
        this.projectConfiguration = projectConfiguration.phases;
        this.lookUps.tasks = mapConfigurationTree(this.projectConfiguration, tasks.tasks);
        this.lookUps.milestone = projectConfiguration.phases.flatMap(x => x.milestones).map(x => {
          return {
            id: x.id,
            title: x.name,
          };
        });
        this.lookUps.areaType = areaTypes.areaTypes.map(x => {
          return {
            id: x.id,
            title: x.name,
          };
        });
        this.lookUps.state = states.stateList.map(x => {
          return {
            id: x.stateId,
            title: x.stateName,
          };
        });
        this.lookUps.country = countries.countryList.map(x => {
          return {
            id: x.countryId,
            title: x.countryName,
          };
        });
        this.lookUps.company = companies.companyItems;
        this.lookUps.person = persons.personItems;
        this.lookUps.remuneration = remunerationTags.remunerationTags.map(x => {
          return {
            id: x.id,
            title: x.title,
          };
        });
        this.lookUps.projectStatus = [
          { id: 'Aktiv', title: 'Aktiv' },
          { id: 'Inaktiv', title: 'Inaktiv' },
          { id: 'Abgeschlossen', title: 'Abgeschlossen' },
          { id: 'Abgebrochen', title: 'Abgebrochen' },
        ];
      }
    } catch (e) {
      AppGlobals.ShowErrorMessage(e);
    }
  }

  async saveTable(e: ClickEvent) {
    var validation = e.validationGroup?.validate();
    if (!validation.isValid) {
      const element = validation.brokenRules[0].validator._$element[0];
      element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    this.appGlobals.ShowGlobalLoader();
    try {
      this.table = this.unGroupData();
      this.table.users = this.table.users.filter(u => u.email);
      this.table.filters = this.table.filters.filter(f => f.type && f.value);

      const result = await this.service.WriteDynamicTable({
        table: this.table,
      });
      if (result.hasError) {
        AppGlobals.ShowErrorMessage(result.feedback);
      } else {
        this.router.navigate([result.tableId], {
          relativeTo: this.route.parent,
        });
      }
    } catch (e) {
      AppGlobals.ShowErrorMessage(e);
    }
    this.appGlobals.HideGlobalLoader();
  }

  async deleteTable(e: ClickEvent) {
    this.table.isDeleted = true;
    this.appGlobals.ShowGlobalLoader();
    try {
      this.table = this.unGroupData();
      const result = await this.service.WriteDynamicTable({
        table: this.table,
      });
      if (result.hasError) {
        AppGlobals.ShowErrorMessage(result.feedback);
      } else {
        this.router.navigate(['tables']);
      }
    } catch (e) {
      AppGlobals.ShowErrorMessage(e);
    }
    this.appGlobals.HideGlobalLoader();
  }

  addGroup() {
    this.data.push({
      groupName: 'New Group',
      fields: [],
    });
  }
  //#region Users
  addUser() {
    this.table.users.push({
      id: 0,
      email: null,
      canEdit: false,
    });
  }

  deleteUser(user) {
    user.isDeleted = true;
    var userType = this.lookUps.users.find(x => x.email == user.email);
    if (userType) userType.disabled = false;
  }
  //#endregion

  //#region Filters
  addFilter() {
    this.editTable.filters.push({
      id: 0,
      type: null,
      value: [],
    });
  }

  deleteFilter(filter) {
    filter.isDeleted = true;
    var filterType = this.filters.find(x => x.value == filter.type);
    if (filterType) filterType.disabled = false;
  }
  //#endregion

  mapData(table: Table) {
    this.editTable = {
      id: table.id,
      title: table.title,
      users: table.users,
      filters: table.filters,
      structure: table.structure.map(x => {
        return {
          id: x.id,
          fieldId: x.fieldId,
          fieldIdentifier: x.fieldIdentifier,
          name: x.displayName,
          sortingIndex: x.sortingIndex,
          group: x.group,
          parentId: x.parentId,
          value1: JSON.parse(x.value1),
          value2: JSON.parse(x.value2),
          isDeleted: false,
          fieldConfig: this.fieldTypeConfigs.find(y => y.fieldIdentifier == x.fieldIdentifier),
          fields:
            x.fields?.map(y => {
              return {
                id: y.id,
                fieldId: y.fieldId,
                fieldIdentifier: y.fieldIdentifier,
                name: y.displayName,
                sortingIndex: y.sortingIndex,
                group: y.group,
                parentId: y.parentId,
                value1: JSON.parse(y.value1),
                value2: JSON.parse(y.value2),
                isDeleted: y.isDeleted,
                fieldConfig: this.fieldTypeConfigs.find(j => j.fieldIdentifier == y.fieldIdentifier),
              };
            }) ?? [],
        };
      }),
    };
  }

  unGroupData(): Table {
    return {
      id: this.editTable.id,
      title: this.editTable.title,
      users: this.editTable.users,
      filters: this.editTable.filters,
      isDefault: this.table.isDefault,
      owner: this.table.owner,
      isDeleted: this.table.isDeleted,
      structure: this.editTable.structure.map((x, i) => {
        return {
          id: x.id,
          fieldId: x.fieldId,
          fieldIdentifier: x.fieldIdentifier,
          displayName: x.name,
          sortingIndex: i + 1,
          group: x.group,
          parentId: null,
          value1: JSON.stringify(x.value1),
          value2: JSON.stringify(x.value2),
          isDeleted: x.isDeleted,
          fields:
            x.fields?.map((y, j) => {
              return {
                id: y.id,
                fieldId: y.fieldId,
                fieldIdentifier: y.fieldIdentifier,
                displayName: y.name,
                sortingIndex: j + 1,
                group: y.group,
                parentId: x.id,
                value1: JSON.stringify(y.value1),
                value2: JSON.stringify(y.value2),
                isDeleted: y.isDeleted,
              };
            }) ?? [],
        };
      }),
    };
  }

  onGroupReorder(e: ReorderEvent) {
    var field = e.fromData[e.fromIndex];
    e.fromData.splice(e.fromIndex, 1);
    if (e.dropInsideItem) {
      e.toData[e.toIndex].fields.push(field);
    } else {
      e.toData.splice(e.toIndex, 0, field);
    }
  }
  onFieldAdd(e: AddEvent) {
    var field = e.fromData[e.fromIndex];
    e.fromData.splice(e.fromIndex, 1);
    e.toData.splice(e.toIndex, 0, field);
  }

  onFieldReorder(e: ReorderEvent) {
    e.fromData.fields.splice(e.fromIndex, 1);
    e.fromData.fields.splice(e.toIndex, 0, e.itemData);
  }

  onFieldDrop(e: AddEvent) {
    const field = e.itemData;
    e.fromData.fields.splice(e.fromIndex, 1);
    e.toData.fields.splice(e.toIndex, 0, field);
    field.group = e.toData.groupName;
    field.sortingIndex = e.toIndex;
  }

  onDragChange(e: DragChangeEvent) {
    let targetNode = e.fromData[e.toIndex];

    if (e.dropInsideItem && !targetNode.group) {
      e.cancel = true;
    }
  }

  back() {
    if (this.tableId == 0) {
      this.router.navigate(['tables']);
    } else {
      this.router.navigate([this.tableId], { relativeTo: this.route.parent });
    }
  }

  //#region Edit Form

  addField(section: EditTableField[]) {
    section.push({
      id: 0,
      fieldId: 1,
      name: null,
      sortingIndex: 0,
      group: false,
      value1: null,
      value2: null,
      isDeleted: false,
      fields: [],
      fieldConfig: null,
    });
  }

  fieldTypeConfigs: FieldTypeConfig[] = [];
  currentFieldTypeConfig: FieldTypeConfig | null = null;

  onEditingStart(event: any) {
    // Find the field type configuration when editing starts
    const fieldId = event.data.fieldId;
    this.updateContextFields(fieldId);
  }
  //Prepare Editor
  customizeEditForm = item => {
    // Add dynamic context fields
    if (this.currentFieldTypeConfig) {
      const contextConfig = this.currentFieldTypeConfig.contextConfig;

      if (contextConfig.value1) {
        this.addContextFieldToForm(item, 'value1', contextConfig.value1);
      }

      if (contextConfig.value2) {
        this.addContextFieldToForm(item, 'value2', contextConfig.value2);
      }
    }
  };
  //Prepare Editor
  onEditorPreparing(e: EditorPreparingEvent) {
    if (e.dataField === 'fieldId') {
      e.editorOptions.onValueChanged = ev => {
        this.updateContextFields(ev.value);
        const field = this.fieldLookup.find(x => x.fieldId == ev.value);
        e.setValue({
          id: ev.value,
          fieldIdentifier: field.fieldIdentifier,
          displayName: field.displayName,
        });
      };
    }
  }

  setCellValue = (rowData, value) => {
    rowData.fieldId = value.id;
    rowData.fieldIdentifier = value.fieldIdentifier;
    rowData.displayName = value.displayName;
  };

  addContextFieldToForm(item, fieldName: string, config) {
    if (item.dataField === fieldName) {
      if (config.lookup) {
        config.options = this.lookUps[config.lookup];
      }

      item.label.text = config.label;
      item.visible = true;
      if (config.type === 'select') {
        item.editorType = 'dxSelectBox';
        item.editorOptions = {
          dataSource: config.options,
          displayExpr: 'name',
          valueExpr: 'id',
        };
      } else if (config.type === 'tasks') {
        item.editorType = 'dxDropDownBox';
        item.editorOptions = {
          readOnly: config.readOnly || false,
          dataSource: config.options,
          displayExpr: 'title',
          valueExpr: 'taskId',
          contentTemplate: (data, container) => {
            const treeViewContainer = document.createElement('div');
            container.append(treeViewContainer);
            const treeView = new dxTreeView(treeViewContainer, {
              items: config.options,
              dataStructure: 'plain',
              keyExpr: 'taskId',
              displayExpr: 'title',
              parentIdExpr: 'parentTaskId',
              selectionMode: 'single',
              selectByClick: true,
              onItemClick: e => {
                data.value = e.itemData.taskId;
                data.component.value = e.itemData.taskId;
                item.value = e.itemData.taskId;

                data.component.option('value', e.itemData.taskId);
                data.component.close();
              },
            });

            return treeViewContainer;
          },
        };
      } else {
        item.editorType = 'dxTextBox';
      }

      if (config.required) {
        item.validationRules = [
          {
            type: 'required',
            message: `${config.label} is required`,
          },
        ];
      }
    }
  }

  updateContextFields(fieldId: number) {
    const field = this.fieldLookup.find(x => x.fieldId == fieldId);
    this.currentFieldTypeConfig =
      this.fieldTypeConfigs.find(config => config.fieldIdentifier === field.fieldIdentifier) || null;
    // this.cdr.detectChanges();
  }

  onGroupCheckboxChanged(e: ValueChangedEventCB, field: EditTableField) {
    if (e.value == true && field.fields.filter(x => x.isDeleted == false).length == 0) {
      const fallbackField = this.fieldLookup.at(0);
      field.fieldId = this.projectIdFieldId;
      field.fieldIdentifier = this.projectIdFieldId ? 'projectId' : fallbackField?.fieldIdentifier || 'projectId';
      field.fieldConfig = null;
      field.value1 = null;
      field.value2 = null;

      field.fields = [
        {
          name: '',
          fieldId: this.projectIdFieldId || fallbackField?.fieldId || 1,
          fieldIdentifier: this.projectIdFieldId ? 'projectId' : fallbackField?.fieldIdentifier || 'projectId',
          group: false,
          fields: [],
          fieldConfig: null,
          id: 0,
          sortingIndex: 1,
          value1: null,
          value2: null,
          isDeleted: false,
        },
      ];
    } else if (e.value == false && field.fields.filter(x => x.isDeleted == false).length > 0) {
      this.popupContent = {
        text: $localize`:@@deleteGroup:Are you sure you want to make this a Field?\nThis will delete all the fields in this group.`,
        confirmFunction: () => {
          field.fields.forEach(x => {
            x.isDeleted = true;
          });
          this.popupContent = null;
        },
        cancelFunction: () => {
          field.group = true;
          this.popupContent = null;
        },
      };
    }
  }

  onFieldChanged($event: ValueChangedEventSB, field) {
    const fieldType = this.fieldLookup.find(x => x.fieldId == $event.value);
    const prevFieldType = this.fieldLookup.find(x => x.fieldId == $event.previousValue);
    field.fieldIdentifier = fieldType.fieldIdentifier;
    field.fieldConfig = this.fieldTypeConfigs.find(x => x.fieldIdentifier == fieldType.fieldIdentifier);
    if (field.name == null || field.name == prevFieldType?.displayName) {
      field.name = fieldType.displayName;
    }
  }

  userValueChanged(e: ValueChangedEventSB) {
    const user = this.lookUps.users.find(x => x.email == e.value);
    const prevUser = this.lookUps.users.find(x => x.email == e.previousValue);
    if (user != null) {
      user.disabled = true;
      if (prevUser != null) {
        prevUser.disabled = false;
      }
    }
  }

  filterValueChanged(e) {
    const filter = this.filters.find(x => x.value == e.value);
    if (filter != null) {
      filter.disabled = true;
    }
  }

  deleteField(field) {
    if (field.group) {
      this.popupContent = {
        text: $localize`:@@deleteGroup:Are you sure you want to delete this group?`,
        confirmFunction: () => {
          field.isDeleted = true;
          field.fields.forEach(x => {
            x.isDeleted = true;
          });
          this.popupContent = null;
        },
        cancelFunction: () => {
          this.popupContent = null;
        },
      };
    } else {
      field.isDeleted = true;
    }
  }

  public projectConfiguration: Phase[] | null = null;

  //#endregion
}
